













































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { HeadersDataTable } from "@/typings/vuetify/vDataTable";
import { Factura } from "@/typings/store/plugins/easyFirestore/facturas";
import { NotaCreditoFactura, notasDeFactura } from "@/helpers/notasCredito";
import { PagoFactura, saldoPorCobrar } from "@/helpers/pagosFacturas";

interface ItemTablaFactura {
  folio: number | string;
  estado: string;
  contrato: number | string;
  cliente: string;
  rut: string;
  periodoFacturado: string;
  montoTotal: number;
  pendientes: number;
  notas: number;
  /** Saldo por cobrar; null si la factura aún no se emite (o está anulada). */
  saldo: number | null;
  data: Factura;
}

const colorPorEstado = (estado: string): string =>
  ({ Aprobada: "teal", Emitida: "blue", Pagada: "green", Anulada: "red" } as Record<string, string>)[
    estado
  ] || "grey";

@Component
export default class TablaFacturas extends Vue {
  @Prop() readonly search!: string;
  @Prop() readonly facturas!: Factura[];
  @Prop({ default: () => [] }) readonly notasCredito!: NotaCreditoFactura[];
  @Prop({ default: () => [] }) readonly pagos!: PagoFactura[];

  get headers(): HeadersDataTable {
    return [
      { text: "Periodo", value: "periodoFacturado", width: "10%" },
      { text: "Contrato", value: "contrato", width: "8%" },
      { text: "Cliente", value: "cliente" },
      { text: "RUT", value: "rut", width: "13%" },
      { text: "Estado", value: "estado", width: "14%" },
      { text: "Folio", value: "folio", width: "9%" },
      { text: "Monto Total", value: "montoTotal", align: "end", width: "12%" },
      { text: "Saldo", value: "saldo", align: "end", width: "11%" },
      { text: "", value: "opciones", sortable: false, align: "end" },
    ];
  }

  get items(): ItemTablaFactura[] {
    return (this.facturas || []).map((factura) => ({
      folio: factura.folio || "—",
      estado: factura.estado,
      contrato: factura.codigoContrato ?? "",
      cliente: factura.clienteSnapshot?.nombre ?? "(sin cliente)",
      rut: factura.clienteSnapshot?.rut ?? "",
      periodoFacturado: String(factura.periodoFacturado ?? ""),
      montoTotal: factura.montoTotal,
      pendientes: (factura.items || []).filter((i) => i.pendiente).length,
      notas: notasDeFactura(this.notasCredito, factura.id).length,
      saldo: ["Emitida", "Pagada"].includes(factura.estado)
        ? saldoPorCobrar(factura, this.notasCredito, this.pagos)
        : null,
      data: factura,
    }));
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(value || 0);
  }

  colorPorEstado(estado: string): string {
    return colorPorEstado(estado);
  }

  @Emit("abrir-info")
  onAbrirInfo(factura: Factura): Factura {
    return factura;
  }

  @Emit("abrir-editar")
  onAbrirEditar(factura: Factura): Factura {
    return factura;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(factura: Factura): Factura {
    return factura;
  }

  @Emit("cambiar-estado")
  onCambiarEstado(factura: Factura, accion: string): { factura: Factura; accion: string } {
    return { factura, accion };
  }
}
